import { F0Box, F0Icon, F0Text } from '@factorialco/f0-react'
import { Link, Pin } from '@factorialco/f0-react/icons/app'
import { Tooltip } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'
import { RawTag } from 'modules/job_catalog/components/customTags/RawTag'
import type { WorkingConditions } from 'modules/job_catalog/lib/workingConditions'

interface WorkingConditionsCardProps {
  workingConditions?: WorkingConditions
}

const WorkingConditionsCard = ({ workingConditions }: WorkingConditionsCardProps) => {
  return (
    <F0Box border="default" borderColor="secondary" borderRadius="md" overflow="hidden">
      <F0Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="between"
        paddingX="md"
        paddingY="sm"
      >
        <F0Box display="flex" flexDirection="row" alignItems="center" gap="sm" maxWidth="80%">
          <F0Text
            content={String(
              workingConditions?.name ?? i18n.t('job_catalog.nodes.working_conditions.default_name')
            )}
            variant="label"
          />
          {workingConditions?.inherited && (
            <Tooltip
              label={i18n.t('job_catalog.nodes.working_conditions.inherited_from', {
                nodeName:
                  workingConditions?.definedAtNode?.name ??
                  workingConditions?.definedAtNode?.uuid ??
                  i18n.t('job_catalog.nodes.working_conditions.parent_node'),
              })}
            >
              <F0Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width="md"
                height="md"
                borderRadius="sm"
                aria-label={String(
                  i18n.t('job_catalog.nodes.working_conditions.inherited_from', {
                    nodeName:
                      workingConditions?.definedAtNode?.name ??
                      workingConditions?.definedAtNode?.uuid ??
                      i18n.t('job_catalog.nodes.working_conditions.parent_node'),
                  })
                )}
                tabIndex={0}
              >
                <F0Icon icon={Link} size="sm" color="secondary" />
              </F0Box>
            </Tooltip>
          )}
        </F0Box>
        <RawTag
          text={String(i18n.t('job_catalog.nodes.working_conditions.all_workplaces'))}
          icon={<F0Icon icon={Pin} size="sm" color="secondary" />}
        />
      </F0Box>
    </F0Box>
  )
}

export default WorkingConditionsCard
